import DrawerMenuPlugin from './plugin.js';

/**
 * ドロワーメニューの初期化
 *
 * このモジュールをページロード時に実行することで、
 * ドロワーメニューを初期化できます。
 *
 * 使用例:
 * ========================================
 * import { initDrawerMenu } from '@/js/drawer-menu/init';
 * initDrawerMenu();
 * ========================================
 */

/**
 * ドロワーメニューをマウント
 *
 * HTML内に id="drawer_menu" 要素がある場合、
 * そこにDrawerMenuコンポーネントをマウントします
 *
 * @param {string} [elementId='drawer_menu'] - マウント対象の要素ID
 * @param component
 */
export function initDrawerMenu(elementId = 'js-drawer_menu', component={}) {
    return DrawerMenuPlugin.mount(elementId,component);
}

